const eventDownloadAPP = (params) => {
  (window as any)?.dataLayer?.push({
    event: `generalEvent`,
    eventName: `footer_${
      params === 'astra-playstore' ? 'android_play_store' : 'ios_app_store'
    }_download`,
    eventCategory: `header & footer navigation`,
    eventAction: `click on ${params === 'astra-playstore' ? 'google play' : 'app store'}`,
    eventLabel: `gunakan aplikasi digiroom`,
  });
};
export default eventDownloadAPP;
